<template>
    <div class="slide-menu">
        <Spinner v-if="loading" class="slide-menu__spinner" />
        <transition
            v-else
            :name="direction"
            @enter="onTransitionEnter"
            @before-leave="onTransitionBeforeLeave"
        >
            <Navigator :key="currentLevelId || 'root'">
                <SlideMenuChildren
                    :items="_items"
                    :current-level-id="currentLevelId"
                    @set-level="setLevel"
                />
            </Navigator>
        </transition>
    </div>
</template>

<script>
import SlideMenuChildren from './SlideMenuChildren.vue';
import Navigator from '@/components/Navigator/Navigator.vue';
import Spinner from '@/components/Spinner';

export default {
    name: 'SlideMenu',

    props: {
        items: { type: Array, default: () => [] },
        loading: { type: Boolean, default: false },
    },

    components: {
        Navigator,
        SlideMenuChildren,
        Spinner,
    },

    data() {
        return {
            direction: undefined,
            currentLevelId: undefined,
        };
    },

    computed: {
        _items() {
            return (this.items || []).reduce((prev, curr, i, arr) => {
                // в результат не будет включён корневой item
                if (curr.id == arr[0].id) {
                    return prev;
                } else if (curr.parentId == arr[0].id) {
                    // у всех прямых потомков убираем родителя
                    curr.parentId = null;
                }
                return [...prev, curr];
            }, []);
        },
    },

    methods: {
        setLevel(id, direction) {
            this.direction = direction;
            this.currentLevelId = id;
        },

        setLevelInitial() {
            const current = this._items.find((item) => item.currentPage === true);

            if (current && current.parentId) {
                this.currentLevelId = current.parentId;
            }
        },

        async scrollActiveIntoView() {
            // await this.$nextTick();
            // const activeElement = this.$el.querySelector(`.navigator-item--active`);
            // if (activeElement) {
            //     activeElement.scrollIntoView({ block: 'top' });
            // }
        },

        onTransitionEnter(el) {
            this.$el.parentElement.scrollTop = 0;
            el.style.top = Math.abs(this.$el.offsetTop) + 'px';
        },

        onTransitionBeforeLeave(el) {
            el.style.top = -this.$el.parentElement.scrollTop + 'px';
        },
    },

    watch: {
        _items(value) {
            if (Array.isArray(value) && value.length) {
                this.setLevelInitial();
            }
        },
    },

    async created() {
        this.setLevelInitial();
        this.scrollActiveIntoView();
    },
};
</script>

<style lang="scss">
.slide-menu {
    position: relative;
    height: 100%;
}

.slide-menu__spinner {
    position: relative;
    top: 50px;
}

$duration: 0.3s;

.in-leave-active,
.in-enter-active {
    transition: transform $duration, opacity $duration;
    position: absolute;
    width: 100%;
    left: 0;
    right: 0;
    top: 0;
}

.in-enter {
    transform: translateX(100%);
    opacity: 1;
}

.in-leave-to {
    transform: translateX(-100%);
    opacity: 0.2;
}

.out-enter-active,
.out-leave-active {
    transition: transform $duration, opacity $duration;
    position: absolute;
    width: 100%;
    left: 0;
    right: 0;
    top: 0;
}

.out-enter {
    transform: translateX(-100%);
}

.out-leave-to {
    transform: translateX(100%);
    opacity: 0.2;
}
</style>
